export interface CookieData {
  msisdn: string;
  token: string;
}

export const setCookie = (msisdn: string, token: string): void => {
  clearAllCookies();
  const data: CookieData = { msisdn, token };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data)
  )}; SameSite=Strict; path=/; max-age=${maxAge}`;
};

export const getCookie = (name: string): CookieData | null => {
  try {
    const cookies = document.cookie.split(";").reduce<Record<string, string>>(
      (acc, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key.trim()] = decodeURIComponent(value ?? "");
        return acc;
      },
      {}
    );
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

export const clearAllCookies = (): void => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = (val: string): void => {
  clearAllCookies();
  if (val === "network") {
    // window.location.href = '/landing'
  }
};
